import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'

import Auftrag9_40Form from './Auftrag9_40Form'
import { useBefehlForm } from '../../../hooks'
import { Befehl9 } from '../../../models'
import { BefehlFormProps, BefehlFormWrapper } from '../Generic'
import {
  convertBefehl9FormDataToModel,
  convertModelToBefehl9FormData
} from './converters'
import { Befehl9FormData, createBefehl9FormValidationSchema } from './schema'
import BefehlFormAuftrag from '../Generic/BefehlFormAuftrag'
import Auftrag9_67_68Form from './Auftrag9_67_68Form'

/**
 * Main form component for Befehl 5
 */
export default function Befehl9Form({
  befehl,
  onSubmit,
  readOnly = false,
  'data-testid': testId = 'befehl-9-form',
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl9>>) {
  const { t } = useTranslation('ui-befehle')

  const formMethods = useBefehlForm<
    ReturnType<typeof createBefehl9FormValidationSchema>
  >({
    readOnly,
    activateEmptyFieldWarnings,
    schema: createBefehl9FormValidationSchema(),
    initialData: befehl ? convertModelToBefehl9FormData(befehl) : undefined
  })

  const handleSubmit = useCallback(
    (data: Befehl9FormData) => {
      const updatedBefehl = convertBefehl9FormDataToModel(
        data,
        befehl.frontendId
      )
      onSubmit(updatedBefehl)
    },
    [befehl.frontendId, onSubmit]
  )

  return (
    <BefehlFormWrapper<Befehl9FormData>
      befehlKennung="9"
      title={t('befehle.9.description')}
      formMethods={formMethods}
      onSubmit={handleSubmit}
      readOnly={readOnly}
      data-testid={`${testId}-wrapper`}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      displayHeaderOnly={displayHeaderOnly}
    >
      {/* Auftrag 9.40 */}
      <Auftrag9_40Form
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-9-40`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />

      <Auftrag9_67_68Form
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-9-67_68`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />

      <BefehlFormAuftrag
        auftragKennung="9.70"
        fieldName={'auftrag_9_70.enabled'}
        readOnly={readOnly}
        testId={`${testId}-auftrag-9-70`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      >
        <span data-testid={`${testId}-auftrag-9-70-text`}>
          {t('auftraege.9_70')}
        </span>
      </BefehlFormAuftrag>

      <BefehlFormAuftrag
        auftragKennung="9.75"
        fieldName={'auftrag_9_75.enabled'}
        readOnly={readOnly}
        testId={`${testId}-auftrag-9-75`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      >
        <span data-testid={`${testId}-auftrag-9-75-text`}>
          {t('auftraege.9_75')}
        </span>
      </BefehlFormAuftrag>
    </BefehlFormWrapper>
  )
}
